import {
  BrowserRouter,
  Outlet,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import Home from "../../pages/Home";
import { routes as routePaths } from "../utilities/utils.constant";
import About from "../../pages/About";
import FaqPage from "../../pages/Faq";
import Contact from "../../pages/ContactUs";
import Blogs from "../../pages/Blogs";
import BlogDescriptionPage from "../../pages/BlogDescriptionPage";
import CMSDevelopment from "../../pages/CMSDevelopment";
import CrossPlatformMobileApps from "../../pages/CrossPlatformMobileApps";
import WebApps from "../../pages/WebApps";
import NativeApps from "../../pages/NativeApps";
import IoTApplications from "../../pages/IoTApplications";
import ContactUs from "../../pages/ContactUs";
import PrivacyPolicy from "../../pages/PrivacyPolicy";
import DefaultLayout from "../../Layout/DefaultLayout";
import GradientHeaderLayout from "../../Layout/GradientHeaderLayout";
import TermsAndConditions from "../../pages/TermsAndConditions";
import Blog1DescriptionPage from "../../pages/BlogDescriptionPage/Blog1DescriptionPage";
import Blog2DescriptionPage from "../../pages/BlogDescriptionPage/Blog2DescriptionPage";
import DigitalMarketing from "../../pages/DigitalMarketing";
import ScrollToTop from "../../components/ScrollToTop";
import AIIntegrationsAndChatbots from "../../pages/AIIntegrationsAndChatbots";
import GraphicAndUIUXDesigning from "../../pages/GraphicAndUIUXDesigning";
import Analytics from "../../components/Analytics";
import WebsiteBriefForm from "../../pages/WebsiteBriefForm";
import GlassEffectHeaderLayout from "../../Layout/GlassEffectHeaderLayout";
import PageNotFound from "../../pages/PageNoteFound";
import TawkToWidget from "../../components/TawkToWidget";
import { useEffect, useState } from "react";
import ReactGA from "react-ga4";
import CookiesModal from "../../components/CookiesModal";
import { CookiesProvider } from "react-cookie";
import MobileAppDevelopment from "../../pages/MobileAppDevelopment";
import SearchEngineOptimization from "../../pages/SearchEngineOptimization";
import PageNoteFoundServer from "../../pages/PageNoteFoundServer";
import DisclaimerBox from "../../components/DisclaimerBox";
import WebsiteBriefFormLogoDesign from "../../pages/WebsiteBriefFormLogoDesign";
import IoTDevelopment from "../../pages/IoTDevelopment";
import NativeAppDevelopment from "../../pages/NativeAppDevelopment";
import CrossPlatformMobileAppDevelopment from "../../pages/CrossPlatformMobileAppDevelopment";
import ThanksPage from "../../pages/ThanksPage";
import WebAppDevelopment from "../../pages/WebAppDevelopment";

// import { routes as routePaths } from "@/config/routes";
function useIsClient() {
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  return isClient;
}
  
const RootLayout = () => {
  const location = useLocation();
  const isClient = useIsClient();

  useEffect(() => {
    if (!isClient) return;

    ReactGA.send({
      hitType: "pageview",
      page: location.pathname,
      title: document.title,
      location: window.location.href,
    });
  }, [location, isClient]);
// useEffect(() => {
//     const disableRightClick = (e) => {
//        if (!e.target.closest(".allow-context")) {
//         e.preventDefault();
//       }
//     };

//     document.addEventListener("contextmenu", disableRightClick);

//     return () => {
//       document.removeEventListener("contextmenu", disableRightClick);
//     };
//   }, []);
  return (
    <>
      {/* <TawkToWidget /> */}
      <CookiesProvider>
        {/* <DisclaimerBox /> */}
        <CookiesModal />
        <ScrollToTop />

        <Outlet />
      </CookiesProvider>
    </>
  );
};

export const routes = [
  {
    element: <RootLayout />,
    children: [
      {
        element: <DefaultLayout />,
        children: [
          { path: routePaths.HOME, element: <Home /> },
          {
            path: routePaths.BLOGDESCRIPTION,
            element: <BlogDescriptionPage />,
          },
         
          // {
          //   path: routePaths.CROSSPLATFORMMOBILEAPPS,
          //   element: <CrossPlatformMobileApps />,
          // },
          { path: routePaths.WEBAPPS, element: <WebApps /> },
          // { path: routePaths.NATIVEAPPLICATIONS, element: <NativeApps /> },
          // { path: routePaths.IOTAPPLICATIONS, element: <IoTApplications /> },
          { path: routePaths.DIGITALMARKETING, element: <DigitalMarketing /> },
          {
            path: routePaths.AIINTEGRATIONSANDCHATBOTS,
            element: <AIIntegrationsAndChatbots />,
          },
          { path: routePaths.BLOG1, element: <Blog1DescriptionPage /> },
          { path: routePaths.BLOG2, element: <Blog2DescriptionPage /> },
        ],
      },
      {
        element: <DefaultLayout darkText={true} />,
        children: [
        
          {
            path: routePaths.MOBILEAPPLICATIONDEVELOPMENT,
            element: <MobileAppDevelopment />,
          },
        
        
        ],
      },
      {
        element: <GlassEffectHeaderLayout seoPage={true} darkText={false} />,
        children: [
          {
            path: routePaths.SEARCHENGINEOPTIMIZATION,
            element: <SearchEngineOptimization />,
          },
        ],
      },
      {
        element: <GlassEffectHeaderLayout seoPage={true} darkText={false} />,
        children: [
          {
            path: routePaths.CROSSPLATFORMMOBILEAPPDEVELOPMENT,
            element: <CrossPlatformMobileAppDevelopment />,
          },
          
          {
            path: routePaths.WEBAPPDEVELOPMENT,
            element: <WebAppDevelopment/>,
          },
          {
            path: routePaths.IOTDEVELOPMENTSERVICE,
            element: <IoTDevelopment />,
          },
          {
            path: routePaths.GRAPHICANDUIUXDESIGNING,
            element: <GraphicAndUIUXDesigning />,
          },
          {
            path: routePaths.NATIVEAPPDEVELOPMENT,
            element: <NativeAppDevelopment />,
          },
          { path: routePaths.CMSDEVELOPMENT, element: <CMSDevelopment /> },
        ],
      },

      {
        element: <GradientHeaderLayout />,
        children: [
          { path: routePaths.THANKSPAGE, element: <ThanksPage  /> },
          { path: routePaths.WEBSITEBRIEFFORM, element: <WebsiteBriefForm /> },
          {
            path: routePaths.WEBSITEBRIEFFORMLOGODESIGN,
            element: <WebsiteBriefFormLogoDesign />,
          },

          { path: routePaths.PRIVACYPOLICY, element: <PrivacyPolicy /> },
          {
            path: routePaths.TERMSANDCONDITIONS,
            element: <TermsAndConditions />,
          },
          { path: "*", element: <PageNotFound /> },
          { path: "/server", element: <PageNoteFoundServer /> },
        ],
      },
      {
        element: <GlassEffectHeaderLayout />,
        children: [
          { path: routePaths.ABOUTUS, element: <About /> },
        
          
          { path: routePaths.CONTACTUS, element: <ContactUs /> },
          { path: routePaths.BLOGS, element: <Blogs /> },
          { path: routePaths.FAQ, element: <FaqPage /> },
        ],
      },
      {
        element: <GlassEffectHeaderLayout darkText={true} />,
        children: [
         
        ],
      },
    ],
  },
];
